import SearchResults from '@molecules/SearchResults/SearchResults';
import Hero from '@organisms/Hero/Hero';
import SearchForm from '@organisms/SearchForm/SearchForm';
import SearchWrapper from '@organisms/SearchWrapper/SearchWrapper';
import Sections from '@organisms/Sections/Sections';
import { SearchPage } from '@type-declarations/page';
import { useState } from 'react';

export default function SearchTemplate({ page }: { page: SearchPage }) {
  const [showPastEvents, setShowPastEvents] = useState(false);
  const {
    sections,
    id,
    recommendationsTitle,
    recommendationsText,
    recommendations,
    noResultsTitle,
    noResultsText,
    noResultItems,
    moreToExploreTitle,
    moreToExploreSubtitle,
    moreToExploreCta,
    moreToExploreLayOver,
    moreToExplore,
  } = page;

  return (
    <SearchWrapper withRouting showPastEvents={showPastEvents}>
      <Hero
        pageId={id}
        title={page.title}
        text={page.introText}
        variant="search"
        colorVariant="primary"
      >
        <SearchForm label={page.searchLabel} />
      </Hero>

      <SearchResults
        showPastEvents={showPastEvents}
        setShowPastEvents={setShowPastEvents}
        noResultItems={noResultItems}
        noResultsTitle={noResultsTitle}
        noResultsText={noResultsText}
        recommendations={recommendations}
        recommendationsTitle={recommendationsTitle}
        recommendationsText={recommendationsText}
        moreToExplore={moreToExplore}
        moreToExploreTitle={moreToExploreTitle}
        moreToExploreSubtitle={moreToExploreSubtitle}
        moreToExploreCta={moreToExploreCta}
        moreToExploreLayOver={moreToExploreLayOver}
      />

      <Sections sections={sections} />
    </SearchWrapper>
  );
}
